export class SignatureUrl {
  public SigningUrl: string;
  public PackageId: string;
}
